import React, { useEffect, useRef, useState } from 'react'
import { CCard, CCardBody, CButton, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CRow, CCol, CFormLabel, CFormInput, CTable, CTableBody, CTableHead, CTableHeaderCell, CTableRow, CTableDataCell, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CSpinner, CBadge } from '@coreui/react'
import AddLabForm from './AddLabForm'
import LabCRUD from '../../services/general/LabsAPI.api.js'
import Carder from '../../components/shared/Carder'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import PatientLabsCRUD from '../../services/general/patientLabsCrud.api'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import HighlightedText from '../../components/shared/HighlightedText'
import CustomDatePickingFormat from '../../../src/components/shared/CustomDatePickingFormat'
import moment from 'moment'
import { X } from 'lucide-react'
const PatientProviderlabs = ({ patientID, loading, setLoading, setDataId, addDiagnosisIdsToNote, saveTreatsShell, setAllLabs, allLabs, diagnosis, updatePatientDiagnosis, noteStructureRef, showComment }) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [currentDate, setCurrentDate] = useState('')
  const [newLabs, setNewLabs] = useState([])
  const [activeTab, setActiveTab] = useState(0)
  const [labList, setLabList] = useState([])
  const [possibleDiagnosis, setPossibleDiagnosis] = useState([])
  const [date, setDate] = useState('')
  const [diagnosisModalVisible, setDiagnosisModalVisible] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [noteEditedLabId, setNoteEditLabId] = useState('')
  const [allDiagnosisListMaster, setAllDiagnosisListMaster] = useState([])
  const [selectedLabsToEdit, setSelectedLabsToEdit] = useState(null)

  useEffect(() => {
    setCurrentDate(getFormattedDate())
    fetchLabs()
    fetchPatientLabs()
  }, [patientID])

  const fetchLabs = async () => {
    let labData = await LabCRUD('GETALL', '{}')
    labData = JSON.parse(labData.d)?.Data
    setLabList(labData)
  }

  const getDiagnosisMaster = async () => {
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data
      const options = diagnosis.map((item) => ({
        id: item.id,
        name: item.Name,
      }))
      setAllDiagnosisListMaster(options)
    } catch (error) {
      console.error('Error updating diagnosis options:', error)
    }
  }

  useEffect(() => {
    getDiagnosisMaster()
  }, [])

  const fetchPatientLabs = async () => {
    try {
      let formattedData
      formattedData = await PatientLabsCRUD('GET', patientID.toString())
      formattedData = JSON.parse(formattedData?.d)
      formattedData = formattedData?.Data || []
      if (formattedData) {
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
      }
      formattedData.sort((a, b) => b.id - a.id)
      // formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date));
      setAllLabs(formattedData)
      return formattedData
    } catch (error) {
      console.log(error)
    }
  }

  const getFormattedDate = (dateStr) => {
    const today = dateStr ? new Date(dateStr) : new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    return `${mm}.${dd}.${yyyy}`
  }

  const addLabToList = (lab) => {
    setNewLabs(lab)
  }

  const handleSaveLabs = async () => {
    if (newLabs.length === 0) {
      toast.error('Please add the labs', toastConfig)
      return
    }
    try {
      const allLabDiag = newLabs
        .map(item => item.diagnosis)
        .filter(item => item !== '')
        .flatMap(item => item.split(',').map(d => d.trim()));
      const uniqueLabDiag = [...new Set(allLabDiag)].filter(Boolean);

      let historyDiagnosis = uniqueLabDiag.reduce((acc, item) => {
        let existingData = noteStructureRef.current?.information?.[item] || [];
        let labObj = newLabs.find(lab => {
          let diagList = lab.diagnosis
              ?.split(",")
              ?.map(d => d.trim().toLowerCase());
          return diagList?.includes(item.toLowerCase());
        });

        if (labObj && labObj.name) {
          if (!existingData.includes(`Labs(${labObj.name})`)) {
            acc[item] = [...existingData, `Labs(${labObj.name})`];
          } else {
            acc[item] = existingData;
          }
        } else {
          acc[item] = existingData;
        }
        return acc;
      }, {});

      noteStructureRef.current = {
        ...noteStructureRef.current,
        information: {
          ...noteStructureRef.current?.information,
          ...historyDiagnosis
        }
      };

      if (selectedLabsToEdit) {
        await PatientLabsCRUD('UPDATE', patientID.toString(), JSON.stringify(newLabs), '', selectedLabsToEdit.id.toString())
        await fetchPatientLabs()
        setModalVisible(false)
        setSelectedLabsToEdit(null)
        setNewLabs([])
        setDiagnosisModalVisible(false)
        toast.success('Successfully Updated', toastConfig)
      } else {
        await PatientLabsCRUD('INSERT', patientID.toString(), JSON.stringify(newLabs), getFormattedDate(date), '')
        setModalVisible(false)
        setSelectedLabsToEdit(null)
        setNewLabs([])
        setDiagnosisModalVisible(false)
        const allLabs = await fetchPatientLabs()
        if (allLabs.length > 0) {
          // setNoteEditLabId(allLabs[allLabs.length - 1]?.id) //could be this
          setNoteEditLabId(allLabs[0]?.id) // could be this
          noteStructureRef.current = {
            ...noteStructureRef.current,
            metadata: {
              ...noteStructureRef.current.metadata,
              labId: allLabs[0]?.id,
            },
          }
          await saveTreatsShell(false)
        }
        toast.success('Successfully Added', toastConfig)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleAddButtonFirst = () => {
    filterDiagnosis()
  }

  const filterDiagnosis = async () => {
    if (newLabs.length === 0) {
      toast.error('Please add the labs', toastConfig)
      return
    }
    const allLab = newLabs
      .map((item) => item.diagnosis)
      .filter((item) => item !== '')
      .flatMap((item) => item.split(',').map((d) => d.trim())) // Split by comma and trim spaces

    const uniqueLabDiagnosis = [...new Set(allLab)].filter(Boolean)

    const diagnosisNotInPatient = uniqueLabDiagnosis.filter((labDiag) => !diagnosis.includes(labDiag))

    if (diagnosisNotInPatient.length > 0) {
      setDiagnosisModalVisible(true)
      setPossibleDiagnosis(diagnosisNotInPatient.map((d) => ({ Name: d })))
    } else {
      handleSaveLabs()
    }
  }

  const addDiagnosis = () => {
    let newDiagnosis = possibleDiagnosis.map((obj) => {
      return obj.Name.trim()
    })

    let historyDiagnosis = newDiagnosis.reduce((acc, item) => {
      let existingData = noteStructureRef.current?.information?.[item] || []
      let labName = newLabs.find((lab) => lab.diagnosis === item)

      if (!existingData.includes(`Labs(${labName?.name})`)) {
        acc[item] = [...existingData, `Labs(${labName?.name})`]
      } else {
        acc[item] = existingData
      }
      return acc
    }, {})

    if (possibleDiagnosis.length > 0) {
      const allDiagnosisIdsToAdd = allDiagnosisListMaster.filter((master) => possibleDiagnosis.some((possible) => possible.Name === master.name)).map((matched) => matched.id)

      if (addDiagnosisIdsToNote) {
        addDiagnosisIdsToNote(allDiagnosisIdsToAdd)
      }
    }
    noteStructureRef.current = {
      ...noteStructureRef.current,
      information: {
        ...noteStructureRef.current.information,
        ...historyDiagnosis,
      },
    }
    newDiagnosis = newDiagnosis.join(',')
    updatePatientDiagnosis(patientID, newDiagnosis)
    setModalVisible(false)
    handleSaveLabs()
  }

  const handleClose = () => {
    setModalVisible(false)
    setSelectedLabsToEdit(null)
  }

  const handleEditLabs = (lab) => {
    setSelectedLabsToEdit(lab)
    setModalVisible(true)
  }

  const handleDeleteLabs = async (id) => {
    await PatientLabsCRUD('DELETE', patientID.toString(), '', '', deleteVisibleId?.toString())
    setDeleteVisibleId(null)
    await fetchPatientLabs()
  }
  const handleRemoveDiagnosis = (indexToRemove) => {
    setPossibleDiagnosis((prevDiagnosis) => prevDiagnosis.filter((_, index) => index !== indexToRemove))
  }

  const handleAddLabs = () => {
    if (allLabs.length > 0 && noteEditedLabId) {
      const findEditNoteLab = allLabs.find((lab) => lab.id === noteEditedLabId)
      if (findEditNoteLab) {
        handleEditLabs(findEditNoteLab)
        // setModalVisible(true)
        // setSelectedLabsToEdit(findEditNoteLab)
      } else {
        setModalVisible(true)
      }
    } else {
      setModalVisible(true)
    }
  }

  // handle edit labs only which linked to this setdataid
  useEffect(() => {
    const labId = noteStructureRef.current?.metadata?.labId
    setNoteEditLabId(labId)
  }, [])

  // useEffect(() => {
  // }, [noteEditedLabId])

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
          <CSpinner color="primary" />
        </div>
      ) : (
        <>
          {/* delete modal */}
          <CModal visible={deleteVisibleId}>
            <CModalHeader>
              <CModalTitle>Warning</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
            </CModalBody>
            <hr className="p-0 m-0" />
            <CModalFooter className="p-3 m-0">
              <CButton
                onClick={() => {
                  setDeleteVisibleId(null)
                }}
                className="text-white"
                color="secondary"
              >
                Close
              </CButton>
              <CButton onClick={handleDeleteLabs} className="text-white" color="danger">
                Delete
              </CButton>
            </CModalFooter>
          </CModal>

          <CModal className="dashboard-dark-modal patient-theme-modal patient-labs-modal" size="lg" visible={diagnosisModalVisible} onClose={() => setDiagnosisModalVisible(false)}>
            <CModalHeader onClose={() => setDiagnosisModalVisible(false)}>
              <CModalTitle>Diagnosis Details</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <div className="d-flex">
                {/* <div style={{ minWidth: "50%", width: "50%" }} className="flex-fill me-3 text-display">
                                    <p style={{ whiteSpace: 'pre-line' }}></p> */}
                {/* <HighlightedText text={textFormatInput} keywords={Array.from(detectedKeywordsRef.current)}></HighlightedText> */}
                {/* </div> */}
                <div className="flex-fill">
                  <h5>Detected Diagnosis</h5>
                  {/* {possibleDiagnosis.map((diagnosis, index) => (
                                        <CBadge key={index} color="info" className="me-2 mr-1 mb-1" style={{ cursor: 'pointer' }}
                                            onClick={() => handleRemoveDiagnosis(index)}>
                                            {diagnosis.Name}
                                        </CBadge>
                                    ))} */}
                  {possibleDiagnosis.map((diagnosis, index) => (
                    <CBadge key={index} color="info" className="d-flex align-items-center gap-2 me-2 mr-1 mb-1 text-white" style={{ cursor: 'pointer', width: 'fit-content', maxWidth: '100%' }}>
                      {diagnosis.Name}
                      <X
                        onClick={() => {
                          handleRemoveDiagnosis(index)
                        }}
                        size={15}
                      />
                    </CBadge>
                  ))}
                  <hr />
                  <h5>Existing Diagnosis</h5>
                  {diagnosis.map((diagnosisItem, index) => (
                    <CBadge key={index} color="primary" className="me-2 mr-1 mb-1">
                      {diagnosisItem}
                    </CBadge>
                  ))}
                </div>
              </div>
            </CModalBody>
            <CModalFooter>
              <CButton variant="outline" color="primary" onClick={addDiagnosis}>
                Add Diagnosis
              </CButton>
              <CButton variant="outline" color="secondary" onClick={handleSaveLabs}>
                Continue without adding
              </CButton>
            </CModalFooter>
          </CModal>

          {/* <CNav className="justify-content-center" variant='pills'>
                        <CNavItem>
                            <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                                Manual Entry
                            </CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink active={activeTab === 1} onClick={() => setActiveTab(1)}>
                                File Upload
                            </CNavLink>
                        </CNavItem>
                    </CNav> */}
          <CTabContent className="overflow-hidden">
            <CTabPane visible={activeTab === 0}>
              {/* <CButton style={{ marginTop: "10px" }} className='' onClick={handleAddLabs} variant="outline" color="primary">
                                + Add Labs
                            </CButton> */}

              {allLabs &&
                allLabs.map((labEntry, index) => {
                  return (
                    <div
                      key={index}
                      // deleteFunc={labEntry.id === noteEditedLabId ? () => { setDeleteVisibleId(labEntry.id) } : null}
                      // editFunc={
                      //     labEntry.id === noteEditedLabId
                      //         ?
                      //         () => handleEditLabs(labEntry)
                      //         : null}

                      className="mt-2"
                      title={`Date: ${new Date(labEntry.date).toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                      })}`}
                      style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', backgroundColor: '#292828ff', overflow: 'auto' }}
                    >
                      <div className="p-3 " style={{ width: '120%' }}>
                        <p>
                          Date:{' '}
                          {new Date(labEntry.date).toLocaleDateString('en-US', {
                            month: '2-digit',
                            day: '2-digit',
                            year: 'numeric',
                          })}
                        </p>
                        <CTable className="table" style={{ tableLayout: 'fixed' }} responsive>
                          <CTableHead>
                            <CTableRow>
                              <CTableHeaderCell style={{ width: '90px', color: 'white' }}>Lab Name</CTableHeaderCell>
                              <CTableHeaderCell style={{ width: '70px', color: 'white' }}>Value</CTableHeaderCell>
                              <CTableHeaderCell style={{ width: '70px', color: 'white' }}>Unit</CTableHeaderCell>
                              <CTableHeaderCell style={{ width: '60px', color: 'white' }}>Range</CTableHeaderCell>
                              <CTableHeaderCell style={{ width: '100px', color: 'white' }}>Diagnosis</CTableHeaderCell>
                              <CTableHeaderCell style={{ width: '200px', color: 'white' }}>Remark</CTableHeaderCell>
                            </CTableRow>
                          </CTableHead>
                          <CTableBody>
                            {labEntry.data?.map((lab, labIndex) => {
                              const value = lab.value ? parseFloat(lab.value) : null
                              const rangeParts = lab.range ? lab.range.split('-').map((part) => parseFloat(part.trim())) : []
                              const isValueInRange = value !== null && rangeParts.length === 2 && value >= rangeParts[0] && value <= rangeParts[1]
                              return (
                                <CTableRow key={labIndex}>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.name}</CTableDataCell>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.value || '-'}</CTableDataCell>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.unit}</CTableDataCell>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.range}</CTableDataCell>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.diagnosis}</CTableDataCell>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.remark}</CTableDataCell>
                                </CTableRow>
                              )
                            })}
                          </CTableBody>
                        </CTable>
                      </div>
                    </div>
                  )
                })}

              {allLabs.length === 0 && <div className="text-center my-4">No Labs Available</div>}
            </CTabPane>
          </CTabContent>
        </>
      )}

      <CModal size="lg" scrollable backdrop={'static'} visible={modalVisible} onClose={handleClose}>
        <CModalHeader onClose={handleClose}>
          <CModalTitle>{selectedLabsToEdit ? 'Update Patient Labs ' : 'Add Patient Labs '}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CRow>
            <CCol className="d-flex flex-column" md={6}>
              <CFormLabel>Date</CFormLabel>
              <CustomDatePickingFormat value={date} onChange={(e) => setDate(e)} />
              {/* <CFormInput type="date" value={date} onChange={(e) => setDate(e.target.value)} /> */}
            </CCol>
          </CRow>
          <AddLabForm selectedLabsToEdit={selectedLabsToEdit} labList={labList} addLabsFn={addLabToList} showComment={showComment} />
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="primary" onClick={handleAddButtonFirst}>
            Add Patient Labs{' '}
          </CButton>
          <CButton variant="outline" color="secondary" onClick={handleClose}>
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientProviderlabs
